/**
 * PANOYA YAZMA — TEK kapi.
 *
 * Pano API'si guvenli baglam (https / localhost) ve izin ister; duz http'de ya da eski bir
 * tarayicida `navigator.clipboard` HIC YOKTUR. DOM tipleri onu her zaman var saydigi icin
 * korumasiz bir `navigator.clipboard.writeText(...)` derlenir ama o ortamda TypeError firlatir:
 * donen promise'in hata kolu hic calismaz ve kullanici IBAN'i kopyaladigini SANIR. Elle
 * yazilan bir IBAN'da hata bu urunde yapilabilecek en pahali hatadir (QuoteCard BankPanel).
 *
 * Sonuc bir BOOLEAN ve bu fonksiyon hicbir zaman firlatmaz: basari/basarisizlik mesajini
 * cagiran gosterir (hangi metnin dogru oldugunu o biliyor), sessiz kalmak ise secenek degil.
 */
export const copyText = async (text: string): Promise<boolean> => {
  // Tip `Clipboard | undefined`; calisma zamaninda `navigator.clipboard` da undefined olabilir.
  const clipboard = typeof navigator === 'undefined' ? undefined : navigator.clipboard;
  if (typeof clipboard?.writeText !== 'function') return false;
  try {
    await clipboard.writeText(text);
    return true;
  } catch {
    // Izin reddi, odak kaybi (belge odakta degil) ya da senkron firlatan bir uygulama.
    return false;
  }
};
